import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const liStyle = css`{
display: block, counter-increment: item, margin-bottom: 0.5em &::before {
  content: counters(item, ".") ".", margin-right: 0.5em, font-weight: bold
}}`;

export const olStyle = css`{
list-style: none, counter-reset: item, padding-left: 1.5em}`;

export const TypographyStyledHeader = styled(Typography)(() => ({
  fontSize: '1.25rem',
  lineHeight: '1.625rem',
  fontWeight: 700,
  wordBreak: 'break-word',
  color: '#004F71',
  fontFamily: 'Calibri'
}));

export const TypographyTitleStyled = styled(Typography)(() => ({
  fontSize: '1.25rem',
  lineHeight: '1.625rem',
  fontWeight: 700,
  wordBreak: 'break-word',
  color: '#004F71',
  fontFamily: 'CalibriLight'
}));

export const TypographyStyled = styled(Typography)(() => ({
  fontSize: '1rem',
  lineHeight: '1.25rem',
  fontWeight: 700,
  wordBreak: 'break-word',
  color: '#002A3A',
  fontFamily: 'CalibriLight'
}));
